import { css } from '@inter-ikea-kompis/web-component';
export default class LawLabelStyle {
    static getStyle() {
        return css `
			:host {
				display: flex;
				flex-direction: column;
			}
		`;
    }
}
//# sourceMappingURL=LawLabelStyle.js.map